<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <navbaroptions
          isBlur="blur border-radius-lg py-2 start-0 end-0 mb-3 shadow"
          v-bind:darkMode="true"
          isBtn="bg-gradient-success"
          :toRoute="`/rate-card/${bypassID}/0`"
        />
      </div>
      <div class="col-12" v-if="!isLoading">
        <argon-alert
          v-if="showAlert"
          color="danger"
          :dismissible="true"
          @close-alert="closeAlert"
        >
          <strong>Tarifa!</strong> Eliminada correctamente!
        </argon-alert>
        <rates-table
          :title="`Tarifas ${title}`"
          :itemsList="rates"
          :bypassID="bypassID"
        />
      </div>
    </div>
  </div>
</template>

<script>
import RatesTable from "./components/RatesTable.vue";
import Navbaroptions from "@/examples/PageLayout/Navbaroptions.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";

export default {
  name: "rates",
  components: {
    RatesTable,
    Navbaroptions,
    ArgonAlert,
  },
  props: {
    bypassID: { type: String, required: true },
    title: { type: String },
  },
  data() {
    return {
      isLoading: true,
      rates: undefined,
      showAlert: false,
    };
  },
  created() {
    // console.log("rates");
    // console.log(this.bypassID);
    this.plain
      .get(`/rates`, { params: { bypassID: this.bypassID } })
      .then((response) => {
        // console.log("RESPONSE NUM RATES");
        // console.log(response.data);
        if (response.data.length !== 0) this.rates = response.data;
        else this.rates = [];
        this.isLoading = false;
        // console.log("RESPONSE RATES");
        // console.log(this.rates);
      })
      .catch((err) => {
        this.rates = [];
        this.isLoading = false;
        console.log(err);
      });
  },
  methods: {
    deleteItemRates(rateID) {
      this.showAlert = true;
      this.rates = this.rates.filter(({ id }) => id !== rateID);
      // console.log("RATES RATES RATES");
      // console.log(this.rates);
      window.scrollTo(0, 0);
    },
    closeAlert() {
      this.showAlert = false;
    },
  },
};
</script>
